<script>
import axios from "axios";
// import simplebar from "simplebar-vue";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
    };
  },
    methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" style="background: #000;">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm"><img src="@/assets/images/logo.png" height="18"/></span>
            <span class="logo-lg"><img src="@/assets/images/logo.png" height="35"/></span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h4 text-primary"> <b>MotherwellSchools</b> </span> <br>
          <small class="me-3"><i class="fas fa-map-marker-alt"></i> Mutungo Hill, Circular Road </small>
          <small><i class="fas fa-phone-alt"></i> +2576 772508421 </small>
        </span>
        
      </div>

      <div class="d-flex">
        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
